export const saleFinalDocStages = [17, 18]
export const purchaseFinalDocStages = [53, 54]
